import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import BOTable, {
  BOColumns,
  BOColumn,
  BOBody,
  BORow,
  BOCell,
} from "app/components/BOComponents/BOTable/BOTable";
import UserDetailTopBar from "./Ops.Users.UserDetailTopBar";
import {
  formatCurrency,
  SnapminLabel,
  formatDate,
  formatStatusColour,
} from "app/utils/filters";

class UserEvents extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      laoding: false,
      user: null,
    };
  }

  componentDidMount() {
    this.runQuery(this.props.match.params.id);
  }

  componentWillReceiveProps(nextProps: any) {
    if (this.props.match.params.id !== nextProps.match.params.id) {
      this.runQuery(nextProps.match.params.id);
    }
  }

  runQuery = (userId: string): void => {
    this.setState({ loading: true });
    this.props.loadEvents
      .refetch({ external_reference: userId })
      .then(({ data: { user } }): void => {
        this.setState({
          user,
          loading: false,
        });
      })
      .catch((error) => console.error(error));
  };

  render() {
    const { loading, user } = this.state;

    const columns = (): JSX.Element => {
      return (
        <BOColumns>
          <BOColumn>Created at</BOColumn>
          <BOColumn>Type</BOColumn>
          <BOColumn>Payment</BOColumn>
          <BOColumn>Friend from</BOColumn>
          <BOColumn>Friend to</BOColumn>
          <BOColumn>Bulk issue user</BOColumn>
          <BOColumn>User Reference</BOColumn>
          <BOColumn>Description</BOColumn>
        </BOColumns>
      );
    };

    const Unknown = () => {
      return <span style={{ color: "darkorange" }}>Unknown</span>;
    };

    const body = (): JSX.Element => {
      return (
        <BOBody>
          {user && user.events.length > 0 ? (
            user.events.map(
              (row, index): JSX.Element => {
                return (
                  <BORow key={index} rowColor={formatStatusColour(row.status)}>
                    <BOCell>{formatDate(row.created_at)}</BOCell>
                    <BOCell>{row.type}</BOCell>
                    <BOCell>
                      {row.payment ? (
                        <SnapminLabel
                          link={`/snapscan/ops/payments/${row.payment.reference}/summary`}
                          snapminLink={row.payment.snapmin_url}
                        >
                          {row.payment.payment_strategy}
                        </SnapminLabel>
                      ) : (
                        "-"
                      )}
                    </BOCell>
                    <BOCell>
                      {row.friend_connection && row.friend_connection.from ? (
                        <SnapminLabel
                          link={`/snapscan/ops/users/${row.friend_connection.from.external_reference}/payments`}
                          snapminLink={row.friend_connection.from.snapmin_url}
                        >
                          {row.friend_connection.from.email}
                        </SnapminLabel>
                      ) : (
                        "-"
                      )}
                    </BOCell>
                    <BOCell>
                      {row.friend_connection && row.friend_connection.to ? (
                        <SnapminLabel
                          link={`/snapscan/ops/users/${row.friend_connection.to.external_reference}/payments`}
                          snapminLink={row.friend_connection.to.snapmin_url}
                        >
                          {row.friend_connection.to.email}
                        </SnapminLabel>
                      ) : (
                        "-"
                      )}
                    </BOCell>
                    <BOCell>
                      {row.wallet_load && row.wallet_load.activity_logs
                        ? row.wallet_load.activity_logs
                            .map((activityLog) => activityLog.username)
                            .join()
                        : "-"}
                    </BOCell>
                    {row.payment && row.payment.filtered_request ? (
                      <BOCell>
                        {JSON.parse(row.payment.filtered_request).options
                          ?.userReference?.value || "-"}
                      </BOCell>
                    ) : (
                      <BOCell>-</BOCell>
                    )}
                    {row.type === "top_up" ? (
                      <BOCell>
                        Topped up with R
                        {formatCurrency(row.payment.payable_amount)}
                      </BOCell>
                    ) : row.type === "p2p_send" ? (
                      <BOCell>
                        {`Sent `}
                        {row.payment ? (
                          `R${formatCurrency(row.payment.payable_amount)}`
                        ) : (
                          <Unknown />
                        )}
                        {` to `}
                        {row.friend_connection && row.friend_connection.to ? (
                          `${row.friend_connection.to.email}`
                        ) : (
                          <Unknown />
                        )}
                      </BOCell>
                    ) : row.type === "p2p_receive" ? (
                      <BOCell>
                        {`Received `}
                        {row.payment ? (
                          `R${formatCurrency(row.payment.payable_amount)}`
                        ) : (
                          <Unknown />
                        )}
                        {` from `}
                        {row.friend_connection && row.friend_connection.from ? (
                          row.friend_connection.from.email
                        ) : (
                          <Unknown />
                        )}
                      </BOCell>
                    ) : row.type === "friend_connection" ? (
                      <BOCell>
                        Made friends with {row.friend_connection.to.email}
                      </BOCell>
                    ) : row.type === "wallet_load" ||
                      row.type === "bulk_issue" ? (
                      <BOCell>
                        Bulk issue amount R
                        {formatCurrency(row.wallet_load.amount)}
                      </BOCell>
                    ) : (
                      <BOCell>
                        {row.payment ? (
                          `R${formatCurrency(row.payment.payable_amount)}`
                        ) : (
                          <Unknown />
                        )}
                        {` at `}
                        {row.merchant ? row.merchant.name : <Unknown />}
                      </BOCell>
                    )}
                  </BORow>
                );
              }
            )
          ) : (
            <BORow>
              <BOCell colSpan="7" align="center">
                No events on user
              </BOCell>
            </BORow>
          )}
        </BOBody>
      );
    };

    return (
      <React.Fragment>
        <UserDetailTopBar />
        <section className="padded">
          <BOTable
            name="wallet_user_events_table"
            columns={columns()}
            body={body()}
            loading={loading}
          />
        </section>
      </React.Fragment>
    );
  }
}

const eventsQuery = graphql(
  gql`
    query($external_reference: ID) {
      user(external_reference: $external_reference) {
        external_reference
        email
        snapmin_url
        events {
          created_at
          type
          status
          payment {
            reference
            payment_strategy
            snapmin_url
            payable_amount
            filtered_request
          }
          merchant {
            id
            name
            snapmin_url
          }
          friend_connection {
            from {
              email
              external_reference
              snapmin_url
            }
            to {
              email
              external_reference
              snapmin_url
            }
          }
          wallet_load {
            amount
            activity_logs {
              username
            }
          }
        }
      }
    }
  `,
  {
    name: "loadEvents",
    options(props: any) {
      return {
        variables: {
          external_reference: props.match.params.id,
        },
      };
    },
  }
);

export default eventsQuery(UserEvents);
